import { useState, useEffect, useCallback } from "react";
import { axiosService } from "network/axios";

export const useTrackingDetails = (selectedProjectId: any | null) => {
  const [trackingDetails, setTrackingDetails] = useState<any>(null);

  const fetchTrackingNumber = useCallback(async () => {
    if (!selectedProjectId) return;
    
    try {
      const resp: any = await axiosService.get(
        `/shipping/tracking/${selectedProjectId}`
      );
      const trackingLink = resp?.data?.tracking_link || null;
      const receiptLink = resp?.data?.receipt_link || null;
      const trackingNumber = resp?.data?.tracking_number || null;

      setTrackingDetails({
        trackingLink,
        receiptLink,
        trackingNumber,
      });
    } catch (err: any) {
      console.log(err);
    }
  }, [selectedProjectId]);

  useEffect(() => {
    fetchTrackingNumber();
  }, [fetchTrackingNumber]);

  return {
    trackingDetails,
    fetchTrackingNumber
  };
};
